import { houseSearchType } from '@lib/config'
import { getFilterObjectData, formatPrice, isValid } from '@lib/utils'
import { size, isArray, map, last, isString, values, forEach } from 'lodash-es'
import { modeType } from '@lib/parse'
import { filterConfig, filterMeta } from '../../combine/filter-modal/meta'
import { 
  priceProps, bedroomsProps, cateogryProps, planProps, 
  cvProps, bathroomsProps 
} from '../../combine/filter-modal/lib'

function activedTest(filterKeysObject, target) {
  let res = false
  if(size(filterKeysObject) === 0) {
    return res
  }

  for(let i = 0, len = target.length; i < len; i++) {
    if(filterKeysObject[target[i]]) {
      res = true
      break
    }
  }

  return res
}

function getBedroomsLabel(bedrooms, th) {
  return bedrooms?.length > 0
    ? th('bedroomTotal', { 
      n: map(bedrooms, (it) => (it === '5' ? '5+' : it)).join(',') 
    }) 
    : th('bedroomCount')
}

function getBathroomsLabel(bathrooms, th) {
  return bathrooms?.length > 0
    ? th('bathroomTotal', { 
      n: map(bathrooms, (it) => (it === '5' ? '5+' : it)).join(',') 
    }) 
    : th('bathroomCount')
}

function getMaxPrice(type) {
  let res
  const priceAlias = filterConfig[type]?.special?.price
  const meta = filterMeta[priceAlias]?.items
  const lastPrice = isArray(meta) ? last(meta)?.label : null
  
  if(isString(lastPrice)) {
    res = parseFloat(last(lastPrice.split('-')))
  }

  return isValid(res) ? res : undefined
}

export function getPriceLabel(price, type, defaultLabel = '') {
  const maxPrice = getMaxPrice(type)
  const [priceFrom, priceTo] = isArray(price) ? price : []
  const startPass = isValid(priceFrom)
  const endPass = isValid(priceTo)
  
  if(!startPass && !endPass) {
    return defaultLabel
  }

  if(priceFrom === 0 && endPass && priceTo > 0) {
    return `<$${formatPrice(priceTo, true, 2)}`
  }
  
  if((maxPrice === priceTo || priceTo === 'any') && startPass) {
    return `$${formatPrice(priceFrom, true, 2)}+`
  }

  return `$${formatPrice(priceFrom, true, 2)}-$${formatPrice(priceTo, true, 2)}`
}

/**
 * tpr = useTranslations('productspec')
 * th = useTranslations('house')
 */
export function getFilterIcons({ tpr, th, apiParam, searchParam, type }) {
  const tmp = []
  const filterKeysObject = getFilterObjectData(apiParam.filter)
  
  if([
    houseSearchType.residential,
    houseSearchType.newHomes,
    houseSearchType.sold,
    houseSearchType.rental,
  ].indexOf(type) > -1) {
    tmp.push(
      {
        label: getPriceLabel(searchParam.price, type, th('price')),
        value: 'price',
        props: priceProps,
        actived: activedTest(filterKeysObject, priceProps)
      },
      {
        label: getBedroomsLabel(searchParam.bedroom, th),
        value: 'bedroom',
        props: bedroomsProps,
        actived: searchParam?.bedroom?.length > 0
      },
      {
        label: getBathroomsLabel(searchParam.bathroom, th),
        value: 'bathroom',
        props: bathroomsProps,
        actived: searchParam?.bathroom?.length > 0
      },
      {
        label: tpr('type'),
        value: 'type',
        props: cateogryProps,
        actived: activedTest(filterKeysObject, cateogryProps)
      },
    )
  }

  // 估价、房产开发
  if([
    houseSearchType.estimate,
    houseSearchType.development,
  ].indexOf(type) > -1) {
    tmp.push(
      {
        label: th('urbanPlanningZoning'),
        value: 'type',
        props: planProps,
        actived: activedTest(filterKeysObject, planProps)
      },
      {
        label: getPriceLabel(searchParam.price, type, th('govcv')),
        value: 'govcv',
        props: cvProps,
        actived: activedTest(filterKeysObject, cvProps)
      },
    )
  }

  // 商业地产，农场
  if([
    houseSearchType.rural,
    houseSearchType.commercialForSale,
    houseSearchType.commercialForLease,
  ].indexOf(type) > -1) {
    tmp.push(
      {
        label: getPriceLabel(searchParam.price, type, th('price')),
        value: 'price',
        props: priceProps,
        actived: activedTest(filterKeysObject, priceProps)
      },
      {
        label: tpr('type'),
        value: 'type',
        props: cateogryProps,
        actived: activedTest(filterKeysObject, cateogryProps)
      },
    )
  }
  
  return tmp
}

/**
 * 获取筛选条件数量
 */
export function getFilterCount(searchParam) {
  let res = 0
  const target = [...values(modeType), 'bedroom', 'carspace', 'bathroom']
  
  forEach(target, (key) => {
    const item = searchParam[key]
    isArray(item) && item.length > 0 && (res += 1)
  })

  if(isArray(searchParam.filters)) {
    res += searchParam.filters.length
  }

  if(isArray(searchParam.price) && searchParam.price.length > 0) {
    res += 1
  }

  return res
}
